//
import { VChip, VIcon } from 'vuetify/lib'
import {
    VAutocomplete,
    /*, VDatePicker, */ VSelect,
    VSwitch, /*  VTextarea,*/ VTextField,
} from 'vuetify/lib'

//
import CrudDataTableHeader from '../CrudDataTableHeader'
import ModelDataTableFilter from '../ModelDataTableFilter'
import ModelDataTablePagination from '../ModelDataTablePagination'
import ModelDataTableToolbar from '../ModelDataTableToolbar'
import ModelDataTableColumnSelector from '../ModelDataTableColumnSelector'

//
import VAutocompleteModel from '../ModelAutocomplete'
import VBtnAction from '../ButtonAction'
import VChipList from '../ChipList'
import VChipLabel from '../Chips/RChipLabel'
import VFloatField from '../Fields/FloatField'
import VCurrencyField from '../Fields/CurrencyField'
import VDateField from '../Fields/DateField'
import VLink from '../Link'

//
import computed from './computed'
import data from './data'
import filters from './filters'
import methods from './methods'
import props from './props'
import watch from './watch'

//
export default {
    name: 'v-data-table-model',
    components: {
        VBtnAction,
        'crud-data-table-filter': ModelDataTableFilter,
        'crud-data-table-header': CrudDataTableHeader,
        ModelDataTablePagination,
        ModelDataTableToolbar,
        ModelDataTableColumnSelector,
        VAutocomplete,
        VAutocompleteModel,
        VChip,
        VChipLabel,
        VChipList,
        VCurrencyField,
        VDateField,
        VIcon,
        VFloatField,
        VLink,
        VSelect,
        VTextField,
        VSwitch,
    },
    computed,
    data,
    filters,
    methods,
    mounted() {

        this.filter = { ...this.initialFilterValues }

        console.log(this.color)

        //
        const firstSort = this.headers.reduce((r, i, idx) => r === -1 && i.sortable ? idx : r, -1)

        //
        if (firstSort>-1) {
            //this.order.index = firstSort
            //this.paginationSync.sortBy = this.headers[firstSort].text
        }

        //
        if (this.remindKey) {
            
            //
            const currentKey = this.remindKey.concat('-pagination-current')
            const limitKey = this.remindKey.concat('-pagination-limit')
            const filterKey = this.remindKey.concat('-filter')
            const searchKey = this.remindKey.concat('-search')

            //
            const current = localStorage.getItem(currentKey)
            const limit = localStorage.getItem(limitKey)
            const filter = localStorage.getItem(filterKey)
            const search = localStorage.getItem(searchKey)

            //
            console.log({ search })

            //
            const diffCurrent = String(this.pagination.current) !== current
            const diffLimit = String(this.pagination.limit) !== limit
            const diffFilter = JSON.stringify(this.filter) !== filter
            const diffSearch = this.toolbar.search !== search

            //
            if (diffCurrent) {
                this.pagination.current = Number(current)
            }

            //
            if (diffLimit) {
                this.pagination.limit = Number(limit || this.rowsPerPage)
            }

            //
            if (diffFilter) {            
                //this.filter = JSON.parse(filter)
                //this.submitFilter(JSON.parse(filter))
                this.initialFilterValues = JSON.parse(filter)
                console.log( diffFilter, JSON.parse(filter) )
            }

            //
            if (diffSearch) {            
                this.toolbar.search = search !== null ? search : ''
                if(this.toolbar.search==='') this.refresh()
            }

            //
            if (!diffLimit && !diffCurrent && !diffFilter && !diffSearch) {
                this.refresh()
            }
        } else {
            this.refresh()
        }

        //
        //console.log({ diffFilter })
    },
    props,
    watch,
}
